<div class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Review & Submit
        </h2>
        
        <div class="w-full flex flex-col items-center gap-2 pb-4 pr-2 border-b border-orange-200">
            <review-parent-interview class="w-full h-full" *ngIf="this.currentCaseId" [caseId]="this.currentCaseId"></review-parent-interview>
        </div>
        <div  *ngIf="this.currentCaseId" class="w-full flex flex-row gap-2 items-center justify-end pt-4">
            <button 
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 oswald-font text-white"
                (click)="$event.preventDefault(); submitParentInterview()"
            >
                Submit
            </button>
        </div>
    </div>
</div>